import React, { Component } from 'react';
import { GraingerAccountContext } from '../../Context/Context';

import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import './Page.scss';
import Banner from './Banner/Banner';

class Page extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  getPage() {
    const { title, shrinkTitle, children, type } = this.props;
    if (type === 'Custom') {
      return children;
    }
    const smallPageTitle = shrinkTitle ? shrinkTitle: title

    return (
      <>
        {type === 'Banner' && <Banner name={{standard: title, small: smallPageTitle}}/>}
        <div className='page-container'>
          {type !== 'Banner' && <h2 className='page-title'>{title}</h2>}
          {children}
        </div>
      </>
    );
  }

  render() {
    const { title } = this.props;

    return (
      <div id={title} className='page-main'>
        <Helmet>
          <title>Grainger Accounting | {title}</title>
        </Helmet>
        {this.getPage()}
      </div>
    );
  }
}

Page.propTypes = {
  title: PropTypes.string.isRequired,
  shrinkTitle: PropTypes.string,
  type: PropTypes.oneOf(['Default', 'Banner', 'Custom'])
};

Page.defaultProps = {
  shrinkTitle: null,
  type: 'Default'
}

Page.contextType = GraingerAccountContext;
export default Page;